<template>
    <v-tooltip v-if="available" top max-width="340">
        <template v-slot:activator="{ on, attrs }">
            <v-btn icon :color="active ? 'primary' : 'grey darken-1'" :aria-pressed="active.toString()" aria-label="Follow the AI" v-bind="attrs" v-on="on" @click="toggle">
                <v-icon>{{ active ? "mdi-cursor-default-click" : "mdi-cursor-default-click-outline" }}</v-icon>
            </v-btn>
        </template>
        <div>
            <strong>Follow the AI: {{ active ? "on" : "off" }}</strong>
            <div class="mt-1">
                While the AI answers, Quaro shows you where each piece of data lives: the cursor opens the project, the tab and the tile, and highlights it. Your chat moves to the top bar next to
                the logo and stays there, so you can keep asking on any page.
            </div>
            <div class="mt-1">Click anywhere on the page and the preview stops on purpose, so it never fights with you. The answer keeps coming in the chat.</div>
        </div>
    </v-tooltip>
</template>

<script>
    import { followAvailable, followWanted, setFollowWanted } from "./aiCursorMap"

    export default {
        name: "AiFollowToggle",
        data: () => ({ active: followWanted() }),
        computed: {
            available() {
                return followAvailable() && !this.$vuetify.breakpoint.smAndDown
            }
        },
        methods: {
            toggle() {
                this.active = !this.active
                setFollowWanted(this.active)
            }
        }
    }
</script>
